// "Chrome 155 · Linux" from a full user-agent string; the full one is the
// cell's tooltip. Order matters: Edge and Opera also say "Chrome".
export const shortAgent = (ua) => {
  if (!ua) return "—";
  const b = ua.match(/(Edg|OPR|YaBrowser|Firefox|Chrome|Safari)\/(\d+)/);
  const name = b ? { Edg: "Edge", OPR: "Opera", YaBrowser: "Yandex" }[b[1]] || b[1] : "Brauzer";
  const os = /Android/.test(ua)
    ? "Android"
    : /iPhone|iPad/.test(ua)
      ? "iOS"
      : /Windows/.test(ua)
        ? "Windows"
        : /Mac OS/.test(ua)
          ? "macOS"
          : /Linux/.test(ua)
            ? "Linux"
            : "";
  return [b ? `${name} ${b[2]}` : name, os].filter(Boolean).join(" · ");
};
